import { MatDialogConfig } from '@angular/material/dialog';
import { ImportDetailModel } from '@app/core/models/imports/import-detail.model';
import { ImportMissingInvoiceNumberModel } from '@app/core/models/imports/import-missing-invoice-number.model';
import { ImportModel } from '@app/core/models/imports/import.model';
import { FaultedInvoiceModel } from '@app/core/models/invoices/faulted-invoice.model';
import { InvoiceModel } from '@app/core/models/invoices/invoice.model';
import { WorkflowModel } from '@app/core/models/workflows/workflow.model';
import { Observable } from 'rxjs';
import { AlertType } from './alert-type.model';

export class ModalHelper {
  processInvoiceModalConfig: MatDialogConfig = {
    height: '12rem',
    width: '50rem',
    disableClose: true,
    data: {
      cancelActionName: 'Annuler',
      validateActionName: 'Valider',
      modalTitle: 'Confirmation',
    },
  };

  genericModalConfig: MatDialogConfig = {
    height: '12rem',
    width: '50rem',
    disableClose: true,
    data: {
      validateActionName: 'Confirmer',
      modalTitle: 'Confirmation',
    },
  };

  forwardModalConfig: MatDialogConfig = {
    height: '30rem',
    width: '50rem',
    data: {},
    panelClass: 'dialog-container-custom',
  };

  ref1ModalConfig: MatDialogConfig = {
    height: '400px',
    width: '50rem',
    data: {},
    panelClass: 'dialog-container-custom',
  };

  forwardInvoiceModalConfig: MatDialogConfig = {
    height: '30rem',
    width: '50rem',
    data: {
      InvoiceNumber: '',
      InvoiceId: '',
    },
    panelClass: 'dialog-container-custom',
  };

  attachInvoiceModalConfig: MatDialogConfig = {
    height: '30rem',
    width: '50rem',
    data: {
      InvoiceNumber: '',
      InvoiceId: '',
    },
  };

  workflowStageValidationConfig: MatDialogConfig = {
    height: '25rem',
    width: '50rem',
    data: {
      ObjectId: '',
      ObjectNumber: '',
      ObjectTypeName: '',
      WorkflowName: '',
      WorkflowStageLevel: '',
      InvoicesId: [],
      ApproveWorkflowStage: null,
      ApproveWorkflowsStage: null,
    },
    panelClass: 'dialog-container-custom',
  };

  complaintConfig: MatDialogConfig = {
    height: '20rem',
    width: '50rem',
    data: {},
    panelClass: 'dialog-container-custom',
  };

  cancelInvoiceInVoucherValidated: MatDialogConfig = {
    height: '20rem',
    width: '50rem',
    data: {},
    panelClass: 'dialog-container-custom',
  };

  progressConfig: MatDialogConfig = {
    height: '15rem',
    width: '50rem',
    data: {
      requestId: '',
    },
  };

  importDetailConfig: MatDialogConfig = {
    height: '28rem',
    width: '55rem',
    data: {
      Import: null,
      Detail: null,
    },
  };

  activityDetailConfig: MatDialogConfig = {
    height: '83vh',
    width: '80rem',
    data: {},
  };

  recipientEntityKeywordsConfig: MatDialogConfig = {
    height: '30rem',
    width: '60rem',
    data: {},
  };

  importMissingInvoiceNumberDocumentModalConfig: MatDialogConfig = {
    height: '36rem',
    width: '50rem',
    data: {
      ImportMissingNumberDocument: {},
      ShowViewButton: false,
    },
    panelClass: 'dialog-container-custom',
  };

  faultedInvoiceModalConfig: MatDialogConfig = {
    height: '35rem',
    width: '50rem',
    data: {
      ImportMissingNumberDocument: {},
    },
  };

  public getGenericMessageModalConfig(message: string): MatDialogConfig {
    const processModal: MatDialogConfig = Object.assign(
      {},
      this.genericModalConfig
    );
    processModal.data.alertType = AlertType.ERROR;
    processModal.data.modalMessage = message;
    return processModal;
  }

  public getProgressConfig(requestId: string): MatDialogConfig {
    const progressModal: MatDialogConfig = Object.assign(
      {},
      this.progressConfig
    );
    progressModal.data.requestId = requestId;
    return progressModal;
  }

  public getTransferUsersModalConfig(
    id: string,
    name: string
  ): MatDialogConfig {
    const forwardModal: MatDialogConfig = Object.assign(
      {},
      this.forwardModalConfig
    );
    forwardModal.data = {
      Id: id,
      Name: name,
    };
    return forwardModal;
  }

  public getActivityDetailConfig(activityId: number): MatDialogConfig {
    const forwardModal: MatDialogConfig = Object.assign(
      {},
      this.activityDetailConfig
    );
    forwardModal.data = {
      ActivityId: activityId,
    };
    return forwardModal;
  }

  public getForwardInvoiceModalConfig(
    invoiceNumber: string,
    invoiceId: string,
    invoiceViewType: string,
    showPickedWarning: boolean,
    originGroupIsOperational: boolean = false
  ): MatDialogConfig {
    const forwardModal: MatDialogConfig = Object.assign(
      {},
      this.forwardModalConfig
    );
    forwardModal.data = {
      InvoiceNumber: invoiceNumber,
      InvoiceId: invoiceId,
      InvoiceViewType: invoiceViewType,
      ShowPickedWarning: showPickedWarning,
      OriginGroupIsOperational: originGroupIsOperational,
    };
    return forwardModal;
  }

  public getAttachModalConfig(
    title: string,
    subtitle: string,
    id: string,
    uploadFile: (id: string, file: File) => Observable<any>
  ): MatDialogConfig {
    const attachdModal: MatDialogConfig = Object.assign(
      {},
      this.attachInvoiceModalConfig
    );
    attachdModal.data = {
      Title: title,
      SubTitle: subtitle,
      Id: id,
      UploadFile: uploadFile,
    };
    attachdModal.height = '30rem';
    return attachdModal;
  }

  public getWorkflowStageValidationConfig(
    objectId: string,
    objectNumber: string,
    objectTypeName: string,
    workflowName: string,
    workflowStageLevel: number,
    isWFPromotion: boolean = false,
    isModifiedInvoice: boolean = false
  ): MatDialogConfig {
    const workflowStageValidationConfig: MatDialogConfig = Object.assign(
      {},
      this.workflowStageValidationConfig
    );
    workflowStageValidationConfig.data = {
      ObjectId: objectId,
      ObjectNumber: objectNumber,
      ObjectTypeName: objectTypeName,
      WorkflowName: workflowName,
      WorkflowStageLevel: workflowStageLevel,
      IsWFPromotion: isWFPromotion,
      IsModifiedInvoice: isModifiedInvoice,
    };
    return workflowStageValidationConfig;
  }

  public getComplaintConfig(): MatDialogConfig {
    const dataConfig: MatDialogConfig = Object.assign({}, this.complaintConfig);
    dataConfig.data = {
      title: 'Mise en litige',
    };
    return dataConfig;
  }

  public getCancelInvoiceInVoucherValidatedConfig(): MatDialogConfig {
    const dataConfig: MatDialogConfig = Object.assign(
      {},
      this.cancelInvoiceInVoucherValidated
    );
    dataConfig.data = {
      title: 'Annuler la validation du traitement',
      isMandatory: true,
    };
    return dataConfig;
  }

  public getReturnOperationnalConfig(): MatDialogConfig {
    const dataConfig: MatDialogConfig = Object.assign({}, this.complaintConfig);
    dataConfig.data = {
      title: "Renvoyer à l'opérationnel",
    };
    return dataConfig;
  }

  public getImportDetailConfig(
    importRow: ImportModel,
    detail: ImportDetailModel
  ): MatDialogConfig {
    const importDetailConfig: MatDialogConfig = Object.assign(
      {},
      this.importDetailConfig
    );
    importDetailConfig.data = {
      Import: importRow,
      Detail: detail,
    };
    return importDetailConfig;
  }

  public getWorkflowStagesValidationConfig(
    objectsId: string[],
    objectTypeName: string
  ): MatDialogConfig {
    const workflowStageValidationConfig: MatDialogConfig = Object.assign(
      {},
      this.workflowStageValidationConfig
    );
    workflowStageValidationConfig.data = {
      ObjectsId: objectsId,
      ObjectTypeName: objectTypeName,
    };
    return workflowStageValidationConfig;
  }

  public getCancelModalConfig(
    data: any,
    disableClose: boolean
  ): MatDialogConfig {
    return {
      disableClose: disableClose,
      data: data,
      height: '49rem',
      width: '70rem',
    } as MatDialogConfig;
  }

  public getPdfViewerConfig(
    invoiceNumber: string,
    invoiceId: string,
    disableClose: boolean
  ): MatDialogConfig {
    return {
      disableClose: disableClose,
      data: {
        InvoiceNumber: invoiceNumber,
        InvoiceId: invoiceId,
      },
      height: '51rem',
      width: '70rem',
    } as MatDialogConfig;
  }

  public getConfirmationConfig(
    message: string,
    validateActionName?: string,
    cancelActionName?: string
  ): MatDialogConfig {
    return {
      height: '14rem',
      width: '42rem',
      disableClose: true,
      data: {
        validateActionName: validateActionName ?? 'Valider',
        cancelActionName: cancelActionName ?? 'Annuler',
        modalTitle: 'Confirmation',
        modalMessage: message,
        alertType: AlertType.CONFIRMATION,
      },
      panelClass: 'dialog-container-custom',
    } as MatDialogConfig;
  }

  public getYesNoConfig(message: string): MatDialogConfig {
    return {
      height: '16rem',
      width: '42rem',
      disableClose: true,
      data: {
        validateActionName: 'Oui',
        cancelActionName: 'Non',
        modalTitle: 'Confirmation',
        modalMessage: message,
        alertType: AlertType.CONFIRMATION,
      },
    } as MatDialogConfig;
  }

  public getImportConfig(importHandler: any): MatDialogConfig {
    return {
      height: '80vh',
      width: '70rem',
      data: {
        importHandler: importHandler,
      },
      disableClose: true,
    } as MatDialogConfig;
  }

  public getApprovalWorkflowConfig(
    workflows: WorkflowModel[]
  ): MatDialogConfig {
    return {
      height: '50vh',
      width: '40rem',
      data: {
        workflows: workflows,
      },
      disableClose: true,
    } as MatDialogConfig;
  }

  public getInformationConfig(message: string): MatDialogConfig {
    return {
      height: '13rem',
      width: '42rem',
      disableClose: true,
      data: {
        validateActionName: 'Ok',
        modalTitle: 'Information',
        modalMessage: message,
        alertType: AlertType.INFORMATION,
      },
    } as MatDialogConfig;
  }

  public getAlertConfig(message: string): MatDialogConfig {
    return {
      height: '13rem',
      width: '42rem',
      disableClose: true,
      data: {
        validateActionName: 'Ok',
        modalTitle: 'Erreur',
        modalMessage: message,
        alertType: AlertType.INFORMATION,
      },
    } as MatDialogConfig;
  }

  public getImportMissingInvoiceNumberDocumentDetail(
    importMissingInvoiceNumberDocument: ImportMissingInvoiceNumberModel,
    showViewButton: boolean = false
  ): MatDialogConfig {
    const dialogModal: MatDialogConfig = Object.assign(
      {},
      this.importMissingInvoiceNumberDocumentModalConfig
    );
    dialogModal.data = {
      ImportMissingInvoiceNumberDocument: importMissingInvoiceNumberDocument,
      ShowViewButton: showViewButton,
    };
    return dialogModal;
  }

  public getFaultedInvoiceModalConfig(
    faultedInvoice: FaultedInvoiceModel
  ): MatDialogConfig {
    const dialogModal: MatDialogConfig = Object.assign(
      {},
      this.faultedInvoiceModalConfig
    );
    dialogModal.data = {
      FaultedInvoice: faultedInvoice,
    };
    return dialogModal;
  }

  public getInvoicePPRLogsConfig(invoice: InvoiceModel): MatDialogConfig {
    return {
      height: '55vh',
      width: '80rem',
      data: {
        invoice: invoice,
      },
      panelClass: 'dialog-container-custom',
    } as MatDialogConfig;
  }

  public getSelectRef1ModalConfig(): MatDialogConfig {
    const ref1Modal: MatDialogConfig = Object.assign({}, this.ref1ModalConfig);
    return ref1Modal;
  }

  public getRecipientEntityKeywordsConfig(): MatDialogConfig {
    const recipientEntityKeywordsModal: MatDialogConfig = Object.assign(
      {},
      this.recipientEntityKeywordsConfig
    );
    return recipientEntityKeywordsModal;
  }
}
